namespace GeniuzPOS.Inventory {
    export class IcParaColumns {
        static columnsKey = 'Inventory.IcPara';
    }
}
